import React from "react";
import InvoiceEditor from "@/pages/sales/InvoiceEditor";
// Wholesale/B2B invoice editor with full detail: warehouses, VAT, split payments, currencies, discounts, terms
export default function POS() { return <InvoiceEditor kind="sale" />; }
